/** Key-derivation helpers shared by the add-entry forms. Split out of
 * AddSlotForm.tsx so component files export only components
 * (react-refresh/only-export-components — same split as publishFindings.ts). */
export const KEY_RE = /^[a-z][a-z0-9_]*$/

export function deriveKey(label: string): string {
  return label
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .replace(/^(?=[0-9])/, 's_')
}
